// assets/furoshiki-picker.js
import { Component } from '@theme/component';

/**
 * @typedef {object} FuroshikiPickerRefs
 * @property {HTMLElement} storyText - The element that displays the pattern's story.
 * @property {HTMLElement} giftThumb - The large featured thumbnail previewing the selected pattern.
 * @property {HTMLElement} furoshikiPill - The pill badge showing the selected pattern's name.
 * @property {HTMLElement} toggleBtn - The "¿Prefieres otro diseño?" toggle button.
 * @property {HTMLElement} optionsGrid - The (collapsible) grid of alternative pattern options.
 * @property {HTMLElement} chevron - The chevron/plus icon inside the toggle button.
 */

/**
 * A custom element that lets shoppers choose which furoshiki pattern
 * they'd like included as the gift-wrap for their Fūwa order, and
 * shows a short line about the pattern's meaning when selected.
 * The alternative options stay collapsed behind a toggle so the
 * default view only shows one large, clear preview image.
 * @extends Component<FuroshikiPickerRefs>
 */
class FuroshikiPicker extends Component {
  handleChange(event) {
    const { story, img, name } = event.target.dataset;
    if (this.refs.storyText && story) {
      this.refs.storyText.textContent = story;
    }
    if (this.refs.giftThumb && img) {
      this.refs.giftThumb.style.backgroundImage = `url('${img}')`;
    }
    if (this.refs.furoshikiPill && name) {
      this.refs.furoshikiPill.textContent = name;
    }
    // Once a choice is made, collapse the options back down so the
    // module returns to its clean, single-image resting state.
    this.closeOptions();
  }

  toggleOptions() {
    const isOpen = !this.refs.optionsGrid.hidden;
    if (isOpen) {
      this.closeOptions();
    } else {
      this.openOptions();
    }
  }

  openOptions() {
    this.refs.optionsGrid.hidden = false;
    this.refs.toggleBtn.setAttribute('aria-expanded', 'true');
  }

  closeOptions() {
    this.refs.optionsGrid.hidden = true;
    this.refs.toggleBtn.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('furoshiki-picker-component', FuroshikiPicker);
